import React from 'react'
import { Container, Tab, Tabs, Box } from '@mui/material'

import EditUserDialog from 'pages/User/EditUser/EditUserDialog'
import UserTable from './UserTable/UserTable'
import UsersOverview from './UsersOverview'
import FilterBar from './FilterBar'
import ConfirmationDialog from './UserTable/ConfirmationDialog'
import ApprovalsTable from './ApprovalsTable/ApprovalsTable'
import { useSelector } from 'react-redux'
import { TABS } from './constants'
import userActions from './actions'
import InactiveUsersTable from './InactiveUsersTable'
import Table from './Table'

const UsersContainer = () => {
    const { selectedTab } = useSelector((state) => state.user)
    const { setTab } = userActions()
    return (
        <Container>
            <UsersOverview />
            <Box mt={4} mb={16}>
                <Table />
            </Box>
            <ConfirmationDialog />
        </Container>
    )
}

export default UsersContainer
